export default "__VITE_ASSET__BOozYO_J__"